/* UER sticky add-to-cart bar.
   Reuses the page's existing product-form for Add to cart (no cart logic
   duplicated) and mirrors the main product's already-formatted price via
   Dawn's existing variant-change pub/sub event. Falls back to a direct
   /cart/add.js call only if no on-page form can be found. */
(function () {
  function init() {
    var bar = document.querySelector('[data-uer-sticky-atc]');
    if (!bar) return;

    var threshold = parseInt(bar.getAttribute('data-show-after') || '600', 10);
    var priceSlot = bar.querySelector('[data-uer-sticky-price]');
    var addBtn = bar.querySelector('[data-uer-sticky-add]');

    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      bar.classList.toggle('is-visible', y > threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        bar.setAttribute('data-variant-id', variant.id);
        if (priceSlot && event.data.sectionId) {
          var mainPrice = document.getElementById('price-' + event.data.sectionId);
          if (mainPrice) priceSlot.innerHTML = mainPrice.innerHTML;
        }
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addBtn.setAttribute('aria-busy', 'true');
        var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
        if (form) {
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.submit();
          }
          setTimeout(function () { addBtn.removeAttribute('aria-busy'); }, 800);
          return;
        }
        var variantId = bar.getAttribute('data-variant-id');
        if (!variantId) { addBtn.removeAttribute('aria-busy'); return; }
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function () {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'uer-sticky-atc' });
            }
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
          })
          .catch(function (err) { console.error(err); })
          .finally(function () { addBtn.removeAttribute('aria-busy'); });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
